import { render, staticRenderFns } from "./SingProduct.vue?vue&type=template&id=03f96fc8&scoped=true&"
import script from "./SingProduct.vue?vue&type=script&lang=js&"
export * from "./SingProduct.vue?vue&type=script&lang=js&"
import style0 from "./SingProduct.vue?vue&type=style&index=0&id=03f96fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f96fc8",
  null
  
)

export default component.exports